import React from 'react';
import ProductSidebarComponent from './ProductSidebarComponent';
import { PageHeader } from '../../components';

const CapacityEnhancement: React.FC = () => {
  return (
    <>
      <PageHeader customClass='bg-breadcrumb-revamp' title="Capacity Enhancement" breadcrumbs={[{ label: "Products", path: "/products" }]} />

      <div className="container-fluid py-5 wow fadeInUp" data-wow-delay="0.1s"
        style={{ visibility: "visible", animationDelay: "0.1s", animationName: "fadeInUp" }}>
        <div className="container">
          <div className="row g-5">

            <div className="col-lg-8">
              <div className="row g-3 mb-5">
                <div className="col-md-6">
                  <img className="img-fluid" src="img/industrial-3.jpg" alt="" />
                </div>
                <div className="col-md-6">
                  <img className="img-fluid" src="img/industrial-1.jpg" alt="" />
                </div>
              </div>
              <h1 className="mb-4">Capacity Enhancement</h1>
              
              <h3 className="mb-4">Overview</h3>
              <p>As industries expand and municipalities grow, the original design capacities of water and wastewater treatment plants often fall short. At Wasser Technochem (I) Ltd., we offer end-to-end capacity enhancement services that allow clients to scale up their existing treatment systems without compromising performance or compliance.</p>
              <p>Whether it's a marginal flow increase or a major scale-up, our engineering and execution teams ensure that the expansion is cost-effective, technically sound, and seamlessly integrated into your current infrastructure.</p>

              <h3 className="mb-4">Scope of Services</h3>
              <div className="row g-4 mb-4">
                <div className="col-md-6">
                  <p><i className="fa fa-search text-primary me-2"></i>Hydraulic study and load assessment</p>
                </div>
                <div className="col-md-6">
                  <p><i className="fa fa-balance-scale text-primary me-2"></i>Flow balancing and equalization tank design</p>
                </div>
                <div className="col-md-6">
                  <p><i className="fa fa-plus text-primary me-2"></i>Additional treatment units (filters, tanks, aerators, clarifiers)</p>
                </div>
                <div className="col-md-6">
                  <p><i className="fa fa-cogs text-primary me-2"></i>Process optimization to handle higher organic and hydraulic loads</p>
                </div>
                <div className="col-md-6">
                  <p><i className="fa fa-hammer text-primary me-2"></i>Civil works, interconnecting piping, and mechanical integration</p>
                </div>
                <div className="col-md-6">
                  <p><i className="fa fa-tools text-primary me-2"></i>Equipment sizing and augmentation (pumps, blowers, diffusers)</p>
                </div>
                <div className="col-md-6">
                  <p><i className="fa fa-plug text-primary me-2"></i>Electrical panel upgrades and load balancing</p>
                </div>
                <div className="col-md-6">
                  <p><i className="fa fa-check-circle text-primary me-2"></i>Recommissioning, validation, and performance guarantee</p>
                </div>
              </div>

              <h3 className="mb-4">Capacity Enhancement Use Cases</h3>
              <div className="row g-4 mb-4">
                <div className="col-md-6">
                  <div className="service-item">
                    <div className="overflow-hidden">
                      <h5><i className="fa fa-expand text-primary me-2"></i>Doubling Capacity</h5>
                      <p>Doubling capacity of WTPs and ETPs without replacing core infrastructure</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="service-item">
                    <div className="overflow-hidden">
                      <h5><i className="fa fa-stream text-primary me-2"></i>Parallel Streams</h5>
                      <p>Adding parallel streams or modular units to existing STPs</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="service-item">
                    <div className="overflow-hidden">
                      <h5><i className="fa fa-filter text-primary me-2"></i>MEE/RO Upgrades</h5>
                      <p>MEE/RO capacity upgrades for higher reject handling</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="service-item">
                    <div className="overflow-hidden">
                      <h5><i className="fa fa-industry text-primary me-2"></i>Industrial Plants</h5>
                      <p>High-traffic periods in food, beverage, pharma or power plants</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="service-item">
                    <div className="overflow-hidden">
                      <h5><i className="fa fa-users text-primary me-2"></i>Municipal Scaling</h5>
                      <p>Population-based scaling of municipal STPs</p>
                    </div>
                  </div>
                </div>
              </div>

              <h3 className="mb-4">Benefits</h3>
              <div className="row g-4 mb-5">
                <div className="col-md-6">
                  <h5><i className="fa fa-check-circle text-success me-2"></i>Environmental Compliance</h5>
                  <p>Post-expansion compliance with all environmental norms</p>
                </div>
                <div className="col-md-6">
                  <h5><i className="fa fa-check-circle text-success me-2"></i>System Resilience</h5>
                  <p>Improved system resilience and peak load handling</p>
                </div>
                <div className="col-md-6">
                  <h5><i className="fa fa-check-circle text-success me-2"></i>Cost Efficiency</h5>
                  <p>Lower per m³ treatment cost via scale efficiencies</p>
                </div>
                <div className="col-md-6">
                  <h5><i className="fa fa-check-circle text-success me-2"></i>Infrastructure Preservation</h5>
                  <p>Avoids the need for full plant reconstruction</p>
                </div>
                <div className="col-md-12">
                  <h5><i className="fa fa-check-circle text-success me-2"></i>Business Growth</h5>
                  <p>Supports business growth and new product/process lines</p>
                </div>
              </div>

              <h3 className="mb-4">Why WTIL?</h3>
              <div className="row g-4">
                <div className="col-md-12">
                  <div className="d-flex">
                    <div className="flex-shrink-0 btn-square bg-primary rounded-circle" style={{ width: "64px", height: "64px" }}>
                      <i className="fa fa-chart-bar text-white"></i>
                    </div>
                    <div className="ms-4">
                      <h5>Proven Results</h5>
                      <p className="mb-0">Proven results in 25–100% capacity augmentation projects</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="d-flex">
                    <div className="flex-shrink-0 btn-square bg-primary rounded-circle" style={{ width: "64px", height: "64px" }}>
                      <i className="fa fa-users text-white"></i>
                    </div>
                    <div className="ms-4">
                      <h5>Full In-house Support</h5>
                      <p className="mb-0">Full in-house support from process, civil, and automation teams</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="d-flex">
                    <div className="flex-shrink-0 btn-square bg-primary rounded-circle" style={{ width: "64px", height: "64px" }}>
                      <i className="fa fa-drafting-compass text-white"></i>
                    </div>
                    <div className="ms-4">
                      <h5>Detailed Engineering</h5>
                      <p className="mb-0">Detailed engineering to maintain treatment quality post-expansion</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="d-flex">
                    <div className="flex-shrink-0 btn-square bg-primary rounded-circle" style={{ width: "64px", height: "64px" }}>
                      <i className="fa fa-clock text-white"></i>
                    </div>
                    <div className="ms-4">
                      <h5>Minimal Downtime</h5>
                      <p className="mb-0">Project delivery with minimal plant downtime</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="d-flex">
                    <div className="flex-shrink-0 btn-square bg-primary rounded-circle" style={{ width: "64px", height: "64px" }}>
                      <i className="fa fa-money-bill-wave text-white"></i>
                    </div>
                    <div className="ms-4">
                      <h5>Cost-effective Execution</h5>
                      <p className="mb-0">Cost-effective, phased execution plans</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-4">
              <ProductSidebarComponent />
            </div>

          </div>
        </div>
      </div>
    </>
  );
};

export default CapacityEnhancement;
